import { useCallback } from 'react';
import { getConversationMessage } from '@wix/ambassador-genie-chat-service-v1-no-entity/http';
export const useGetUserMessage = httpClient => {
  return useCallback(async messageId => {
    try {
      const res = await httpClient.request(getConversationMessage({
        messageId
      }));
      return res.data.conversationMessage;
    } catch (error) {
      console.error('Error getting conversation message', error);
      throw error;
    }
  }, [httpClient]);
};
//# sourceMappingURL=useGetUserMessage.js.map